import {
  accountsNotificationsCatalogActions,
  accountsValidationsErrorsActions,
  commonNotificationsCatalogActions,
  commonValidationsErrorsActions,
  mailboxNotificationsCatalogActions,
  mailboxValidationsErrorsActions,
  positionNotificationsCatalogActions,
  positionValidationsErrorsActions,
  toolsNotificationsCatalogActions,
  toolsValidationsErrorsActions,
  userNotificationsCatalogActions,
  userValidationsErrorsActions,
} from '@repo/catalogs-store'
import { all, put, takeEvery } from 'redux-saga/effects'
import { loadCatalogsAction } from '../../store/actions'

const initialSagas = [
  put(accountsNotificationsCatalogActions.getRequest({ domain: 'accounts' })),
  put(positionNotificationsCatalogActions.getRequest({ domain: 'position' })),
  put(userNotificationsCatalogActions.getRequest({ domain: 'user' })),
  put(toolsNotificationsCatalogActions.getRequest({ domain: 'tools' })),
  put(commonNotificationsCatalogActions.getRequest({ domain: 'common' })),
  put(mailboxNotificationsCatalogActions.getRequest({ domain: 'mailbox' })),
  put(accountsValidationsErrorsActions.getRequest({ domain: 'accounts' })),
  put(positionValidationsErrorsActions.getRequest({ domain: 'position' })),
  put(toolsValidationsErrorsActions.getRequest({ domain: 'tools' })),
  put(commonValidationsErrorsActions.getRequest({ domain: 'common' })),
  put(userValidationsErrorsActions.getRequest({ domain: 'user' })),
  put(mailboxValidationsErrorsActions.getRequest({ domain: 'mailbox' })),
]

export function* loadCatalogs() {
  try {
    yield all(initialSagas)
  } catch (ex: unknown) {
    console.log(ex)
  }
}

export function* watchLoadCatalogs() {
  yield takeEvery(loadCatalogsAction.type, loadCatalogs)
}
